/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import {
    b2bRedirection as b2bRedirectionSelector,
    authFlow as authFlowSelector,
} from 'ggApp/modules/auth/selectors';
import { transitionTo as transitionToAction } from 'ggApp/modules/router/actions';
import { AuthModal } from 'ggApp/modules/auth/v3';

function withCheckoutTransitionGuard(WrappedComponent) {
    class CheckoutTransitionGuardHOC extends Component {
        constructor(props) {
            super(props);

            this.state = {
                flowName: null,
            };
        }

        handleModalClosing = () => {
            // The default flow state should be set after modal close
            // to prevent a bug when AuthFlow state is not updated
            // if trying open modal with the same flow name
            this.setState({ flowName: null });
        };

        setModalRef = (modalRef) => {
            this.modal = modalRef;
        };

        openModalWithFlow = (flowName) => {
            this.setState({ flowName }, () => {
                if (this.modal) {
                    this.modal.openModal();
                }
            });
        };

        handleTransition = (event) => {
            const { externalTransition, transitionTo, b2bRedirection, authFlow } = this.props;

            if (event && event.preventDefault) {
                event.preventDefault();
            }

            if (b2bRedirection.shouldBeRedirectedToBusiness) {
                return;
            }

            if (authFlow) {
                this.openModalWithFlow(authFlow);
                return;
            }

            // If the account is verified and completed it is safe to transition to checkout
            transitionTo('/checkout', externalTransition);
        };

        render() {
            const {
                // Filter props
                externalTransition,
                transitionTo,
                // Source component props
                ...restProps
            } = this.props;

            const { flowName } = this.state;

            return (
                <React.Fragment>
                    <WrappedComponent {...restProps} onClick={this.handleTransition} />

                    <AuthModal
                        modalRef={this.setModalRef}
                        flow={flowName}
                        onSuccess={this.handleTransition}
                        onClose={this.handleModalClosing}
                        options={{ hasSuccessSignupStep: false, isCheckout: true }}
                    />
                </React.Fragment>
            );
        }
    }

    CheckoutTransitionGuardHOC.propTypes = {
        externalTransition: PropTypes.bool,
        transitionTo: PropTypes.func.isRequired,
        b2bRedirection: PropTypes.shape({
            shouldBeRedirectedToBusiness: PropTypes.bool,
        }).isRequired,
        authFlow: PropTypes.string.isRequired,
    };

    CheckoutTransitionGuardHOC.defaultProps = {
        externalTransition: false,
    };

    const enhance = compose(
        connect(
            createStructuredSelector({
                b2bRedirection: b2bRedirectionSelector,
                authFlow: authFlowSelector,
            }),
            (dispatch) => ({
                transitionTo: bindActionCreators(transitionToAction, dispatch),
            }),
        ),
    );

    return enhance(CheckoutTransitionGuardHOC);
}

export default withCheckoutTransitionGuard;
